import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import CustomSelect from "components/Input/CustomSelect.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import { getSite } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { mbmtab } from "variables/patrimoine";
import { mbmcriticityData } from "variables/lists/patrimoine";
import { NotificationManager } from 'react-notifications';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


export default function MBM(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [mbm, setMbm] = useState("");
  const [mbminstalled, setMbminstalled] = useState(false);
  const [criticity, setCriticity] = useState(1);

  const handleMbminstalledChange = (event) => { setMbminstalled(!mbminstalled) };
  const handleCriticityChange = (event) => { setCriticity(event.target.value); };



  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "mbm"),
        {
          ...mbm,
          mbminstalled,
          criticity,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "mbm"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setMbm(res.data.detail.mbm || {});
        setMbminstalled(res.data.detail.mbm?.mbminstalled);
        setCriticity(res.data.detail.mbm?.criticity);
      });
  }, []);

  const classes = useStyles();

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ margin: "1.3rem 0rem" }}>
            <div><CustomSwitch disabled={!realestateupdate} inputTitle={mbmtab.mbminstalled} checkedState={mbminstalled} handleSwitchChange={handleMbminstalledChange} /></div>
          </div>
        </GridItem>
        {mbminstalled ? (
          <>
            <GridItem xs={12} sm={4} md={4}>
              <div>
                <CustomSelect
                  inputTitle={mbmtab.criticity}
                  selectValue={criticity}
                  handleSelectValueChange={handleCriticityChange}
                  data={mbmcriticityData}
                  disabled={!realestateupdate}
                />
              </div>
            </GridItem>
          </>
        ) : (<></>)}


        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}
